// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeneratePdfFromHtmlRequest } from './generatePdfFromHtmlRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GenerateAndSavePdfFromHtmlRequest {
    'type': number;
    'data': GeneratePdfFromHtmlRequest | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GenerateAndSavePdfFromHtmlRequest>> = [
        {
            "name":     "type",
            "baseName": "type",
            "type":     "number"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "GeneratePdfFromHtmlRequest"
        },
    ];

    static getAttributeTypeMap() {
        return GenerateAndSavePdfFromHtmlRequest.attributeTypeMap;
    }
}
